import { useAppNavigate } from '~/pages';
import { Plan, useSpringBigStore } from '@springbig/shared';
import Section from '~/shared/Section';
import React, {
    useCallback,
    useEffect,
    useState
} from 'react';
import SubscribeFlow from '~/pages/subscriptions/components/SubscribeFlow';
import ManageFlow from '~/pages/subscriptions/components/ManageFlow';

type Flow = 'subscribe' | 'manage';

const SubscriptionDetailsScreen = () => {

    const { navigate, params } = useAppNavigate();
    const { member } = useSpringBigStore();

    const [plan, setPlan] = useState<Plan>(null);
    const [flow, setFlow] = useState<Flow>(null);

    const initializeFlow = useCallback(() => {

        if (!member) {
            return;
        }

        const _plan = member.subscription_plans.find((selectedPlan) => {

            return selectedPlan.status === 'active' && selectedPlan.id?.includes(params.plan_id);
        });

        if (!_plan) {
            // plan not found, send user back to subscriptions list
            navigate(`w/${params.wallet_id}/subscriptions`);
        }

        setPlan(_plan);

        if (_plan.subscription) {
            setFlow('manage');
        }
        else {
            setFlow('subscribe');
        }
    }, [member, params, navigate]);

    useEffect(() => {

        initializeFlow();
    }, [member, initializeFlow]);

    return (
        <Section
            flex={1}
            w={'100%'}
            overflowY={'auto'}
            overflowX={'hidden'}
        >
            { member && !!member.subscriptions_enabled && plan && flow === 'manage' ?
                <ManageFlow plan={plan} />
                :
                <SubscribeFlow plan={plan} />
            }
        </Section>
    );
};

export default SubscriptionDetailsScreen;
